import React, { useEffect, useState, useRef } from "react";
import VendorHeader from "../../CustomComponents/Property/VendorHeader/VendorHeader";
import InventoryUpdate from "../../CustomComponents/InventoryUpdate/InventoryUpdate";
import { currentDateSingle, textDateFormatter } from "../../utils/utils";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import SideBar from "../../CustomComponents/Property/SideBar/SideBar";
import Flatpickr from "react-flatpickr";
import Loader from "../../CustomComponents/Loader/Loader";
import NoDataFound from "../../CustomComponents/NoDataFound/NoDataFound";
import { showSuccessToast } from "../../assets/toastUtils";
import SliderComponentSkeleton from "../../CustomComponents/SliderComponentSkelon/SliderComponentSkeleton";
import SliderInventoryUpdate from "../../CustomComponents/InventorySliderComponents/SliderInventoryUpdate";
import InventoryBulkBlock from "../../CustomComponents/InventorySliderComponents/InventoryBulkBlock";
import InventoryUnblock from "../../CustomComponents/InventorySliderComponents/InventoryUnblock";
import InventoryRatesUpdate from "../../CustomComponents/InventorySliderComponents/InventoryRatesUpdate";

const Inventory = () => {
  const [inventoryData, setInventoryData] = useState([]);
  const [updatePopup, setUpdatePopup] = useState(false);
  const [updateDate, setUpdateDate] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [loader, setLoader] = useState(false);

  // const [fromDate, setFromDate] = useState("");
  // const [toDate, setToDate] = useState("");
  const [startDate, setStartDate] = useState(currentDateSingle);
  // unblocked
  const [unblockedPopup, setUnblockedPopup] = useState(false);
  const handleUnblocked = () => {
    setUnblockedPopup(true);
  };
  const vendorToken = localStorage.getItem("token");

  const handleUpdateDate = (id) => {
    setSelectedId(id);
    setUpdateDate(true);
  };

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const { id } = useParams();

  // const InventoryDetails = (id, startDate) => {
  //   setLoader(true);

  //   // if (!startDate) {
  //   //   toast.error("Start date is not defined.");
  //   //   return;
  //   // }
  //   const myHeaders = new Headers();
  //   myHeaders.append("key", process.env.REACT_APP_API_KEY);

  //   const requestOptions = {
  //     method: "GET",
  //     headers: myHeaders,
  //     redirect: "follow",
  //   };

  //   fetch(
  //     `${process.env.REACT_APP_APP_URL}/api/v1/vendor/hotel-inventory/${id}/list?filterDate=${startDate}`,
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       // console.log(result);

  //       if (result.success) {
  //         setInventoryData(result?.inventory);
  //         setLoader(false);
  //       } else {
  //         setLoader(false);
  //       }
  //       // console.log(result);
  //     })
  //     .catch((error) => setLoader(false));
  // };

  const InventoryDetails = async (id, startDate) => {
    setLoader(true);
    try {
      const headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", `Bearer ${vendorToken}`);
      headers.append("Cookie", process.env.REACT_APP_COOKIE);

      const formData = new FormData();
      formData.append("filterDate", startDate);

      const requestOptions = {
        method: "POST",
        headers: headers,
        body: formData,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/inventory/fetch/${id}`,
        requestOptions
      );

      const result = await response.json();
      if (result.success) {
        setInventoryData(result?.data);
        setCategories(result?.data);
        setSelectedRoom(result?.data[0]);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching room rates:", error);
    }
  };

  useEffect(() => {
    if (id && startDate) {
      InventoryDetails(id, startDate);
    }
  }, [id, startDate]);

  // const handleDateChange = (e) => {
  //  setDate
  // };

  // const handleDateChange = (date) => {
  //   if (date.length > 0) {
  //     // Convert the date to the local time zone and format it
  //     const selectedDate = date[0];
  //     const zonedDate = utcToZonedTime(selectedDate, 'America/New_York'); // Replace with your time zone
  //     const formattedDate = format(zonedDate, 'yyyy-MM-dd'); // Format date as YYYY-MM-DD
  //     setStartDate(formattedDate);
  //   }
  // };

  const handleOnUpdate = () => {
    setUpdatePopup(true);
  };

  const handleClosePopup = () => {
    setUpdatePopup(false);
  };

  const handleCloseUpdateDate = () => {
    setUpdateDate(false);
  };

  const fetchUpdateDate = async () => {
    const headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${vendorToken}`);
    headers.append("Cookie", process.env.REACT_APP_COOKIE);

    const body = JSON.stringify({
      type: "block",
      "from-date": fromDate,
      "to-date": toDate,
    });

    const requestOptions = {
      method: "POST",
      headers,
      body,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/inventory/block/${id}/${selectedId}`,
        requestOptions
      );
      const result = await response.json();
      if (result.success) {
        setUpdateDate(false);
        showSuccessToast(result.message);
        InventoryDetails(id, startDate);
        setFromDate("");
        setToDate("");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchUnblockedDate = async () => {
    const headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${vendorToken}`);
    headers.append("Cookie", process.env.REACT_APP_COOKIE);

    const body = JSON.stringify({
      type: "unblock",
      "from-date": fromDate,
      "to-date": toDate,
    });

    const requestOptions = {
      method: "POST",
      headers,
      body,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/inventory/block/${id}/${selectedId}`,
        requestOptions
      );
      const result = await response.json();
      if (result.success) {
        setUpdateDate(false);
        setUnblockedPopup(false);
        showSuccessToast(result.message);
        InventoryDetails(id, startDate);
        setFromDate("");
        setToDate("");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const dateInputRef = useRef(null);

  const handleFocus = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker();
    }
  };
  const getMonthText = (date) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return monthNames[new Date(date).getMonth()];
  };

  const baseUrl = "https://connect.travcatalyst.com";
  const [categories, setCategories] = useState([]);
  const currentDate = new Date();

  const [showBookingSlider, setShowBookingSlider] = useState(false);
  const [sliderHeading, setSliderHeading] = useState("");
  const [selectedValues, setSelectedValues] = useState([]);
  const [viewType, setViewType] = useState("channel_view");
  const [selectedRoom, setSelectedRoom] = useState({});
  const [selectedChannel, setSelectedChannel] = useState({});

  const handleBulkControlChange = (event) => {
    const data = event.target.value;
    switch (data) {
      // case "Stay Restrictions": {
      //   setShowBookingSlider(true);
      //   setSliderHeading(data);
      //   break;
      // }
      // case "Stop Sell Active": {
      //   setShowBookingSlider(true);
      //   setSliderHeading(data);
      //   break;
      // }
      // case "Stop Sell Inactive": {
      //   setShowBookingSlider(true);
      //   setSliderHeading(data);
      //   break;
      // }

      case "Inventory": {
        setShowBookingSlider(true);
        setSliderHeading(data);
        break;
      }
      // case "Rates": {
      //   setShowBookingSlider(true);
      //   setSliderHeading(data);
      //   break;
      // }
      case "Block": {
        setShowBookingSlider(true);
        setSliderHeading(data);
        break;
      }
      case "Unblock": {
        setShowBookingSlider(true);
        setSliderHeading(data);
        break;
      }

      case "Rates": {
        setShowBookingSlider(true);
        setSliderHeading(data);
        break;
      }

      default:
        break;
    }
  };

  const handleRoomCategoryChange = (data) => {
    setSelectedRoom(inventoryData.filter((item) => item.id === data)[0]);
  };

  console.log(showBookingSlider, 'showBookingSlider');


  return (
    <>
      {/* <div className="sidebar_main_div new_sidebar_main_div">
        <SideBar allPropertiesPage={false} /> */}
      {/* <div className="agent-info-container"> */}
      {/* <VendorHeader showSelectProperty={true} vendorProperty={false} /> */}

      <section className="mt-20 bg-white-div p_0 mt-10">
        <div className="flex justify_content_between align_items_center flex_wrap p_10">
          <h4>Inventory</h4>
          <div className="flex flex_gap_10 align_items_center align_top">
            {/* <Flatpickr
                className="dateBtn_inventory m_0 fit-width"
                value={startDate}
                onChange={handleDateChange}
                options={{ dateFormat: "Y-m-d" }} // Set the date format
              /> */}

            {/* <button className="secondary_btn fit-width">
                {textDateFormatter(currentDateSingle)}
              </button> */}

            <div className="">
              {" "}
              <input
                type="date"
                className="dateBtn_inventory m_0 fit-width"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                ref={dateInputRef}
              ></input>
            </div>

            <button className="vendor_common_property" onClick={handleOnUpdate}>
              Bulk Update
            </button>

            <select className="p-1 border rounded w-16" onChange={handleBulkControlChange}>
              <option value="">Bulk Updates</option>
              <option value="Inventory">Inventory</option>
              <option value="Block">Block</option>
              <option value="Unblock">Unblock</option>
              <option value="Rates">Rates</option>
            </select>
          </div>
        </div>

        {loader ? (
          <Loader size="4em" color="#009A50" />
        ) : (
          <div className="overflow_x_scroll_y_hidden">
            {inventoryData?.length > 0 ? (
              <>
                <table className="inventory_table m_0 table_data_padding">
                  <tr>
                    <th style={{ borderTop: "0.5px solid #cccccc96" }}>
                      Room Category
                    </th>
                    {inventoryData?.[0]?.inventory?.map((data, index) => {
                      // return <th key={index}>{textDateFormatter(data?.date)}</th>;
                      return (
                        <th
                          key={index}
                          className="new_table_th"
                          style={{ borderTop: "0.5px solid #cccccc96" }}
                        >
                          <span className="date_inventory new_date_inventory text-uppercase" style={{ float: 'right' }}>
                            <h4 style={{ color: "#fff", lineHeight: "100%" }}>
                              {" "}
                              {new Date(data.date).getDate()}
                            </h4>{" "}
                            {getMonthText(data.date)}
                          </span>{" "}
                        </th>
                      );
                    })}
                    {/* {item?.inventory?.map((data) => {
                      return <th>{textDateFormatter(data?.date)}</th>;
                    })} */}
                  </tr>
                  {inventoryData?.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td>
                            <div className="flex align_items_center flex_gap_5">
                              <div>{item?.name} </div>
                              <div>
                                <svg
                                  onClick={() => handleUpdateDate(item?.roomId)}
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <mask
                                    id="mask0_7208_10904"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="20"
                                    height="20"
                                  >
                                    <rect
                                      width="20"
                                      height="20"
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_7208_10904)">
                                    <path
                                      d="M5.25646 17.9167C4.8409 17.9167 4.4859 17.7695 4.19146 17.4752C3.89715 17.1808 3.75 16.8258 3.75 16.4102V8.58978C3.75 8.17423 3.89715 7.81923 4.19146 7.52478C4.4859 7.23048 4.8409 7.08332 5.25646 7.08332H6.25V5.41666C6.25 4.3761 6.61486 3.49096 7.34458 2.76124C8.07431 2.03152 8.95944 1.66666 10 1.66666C11.0406 1.66666 11.9257 2.03152 12.6554 2.76124C13.3851 3.49096 13.75 4.3761 13.75 5.41666V7.08332H14.7435C15.1591 7.08332 15.5141 7.23048 15.8085 7.52478C16.1028 7.81923 16.25 8.17423 16.25 8.58978V16.4102C16.25 16.8258 16.1028 17.1808 15.8085 17.4752C15.5141 17.7695 15.1591 17.9167 14.7435 17.9167H5.25646ZM5.25646 16.6667H14.7435C14.8184 16.6667 14.8799 16.6426 14.9279 16.5946C14.976 16.5465 15 16.4851 15 16.4102V8.58978C15 8.51492 14.976 8.45346 14.9279 8.40541C14.8799 8.35735 14.8184 8.33332 14.7435 8.33332H5.25646C5.1816 8.33332 5.12014 8.35735 5.07208 8.40541C5.02403 8.45346 5 8.51492 5 8.58978V16.4102C5 16.4851 5.02403 16.5465 5.07208 16.5946C5.12014 16.6426 5.1816 16.6667 5.25646 16.6667ZM10 13.9583C10.4049 13.9583 10.7492 13.8165 11.0329 13.5329C11.3165 13.2492 11.4583 12.9049 11.4583 12.5C11.4583 12.0951 11.3165 11.7508 11.0329 11.4671C10.7492 11.1835 10.4049 11.0417 10 11.0417C9.59514 11.0417 9.25083 11.1835 8.96708 11.4671C8.68347 11.7508 8.54167 12.0951 8.54167 12.5C8.54167 12.9049 8.68347 13.2492 8.96708 13.5329C9.25083 13.8165 9.59514 13.9583 10 13.9583ZM7.5 7.08332H12.5V5.41666C12.5 4.72221 12.2569 4.13193 11.7708 3.64582C11.2847 3.15971 10.6944 2.91666 10 2.91666C9.30556 2.91666 8.71528 3.15971 8.22917 3.64582C7.74306 4.13193 7.5 4.72221 7.5 5.41666V7.08332Z"
                                      fill="#1C1B1F"
                                    />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </td>
                          {item?.inventory?.map((data, index) => {
                            return (
                              <td key={index}>
                                <span
                                  className="relative new_inventory_no_box"
                                  onClick={() =>
                                    data.blocked === true
                                      ? [
                                        handleUnblocked(),
                                        setToDate(data.date),
                                        setFromDate(data.date),
                                        setSelectedId(item?.roomId),
                                      ]
                                      : null
                                  }
                                  style={
                                    data.blocked === true
                                      ? {
                                        backgroundColor: "#FFD2CC",
                                        cursor: "pointer",
                                      }
                                      : {}
                                  }
                                >
                                  {data?.total_rooms}
                                  {data.blocked === true ? (
                                    <>
                                      <svg
                                        style={{
                                          position: "absolute",
                                          right: "2px",
                                          top: "2px",
                                        }}
                                        width="10"
                                        height="14"
                                        viewBox="0 0 10 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M1.20517 13.3333C0.873722 13.3333 0.59 13.2153 0.354 12.9793C0.118 12.7433 0 12.4596 0 12.1281V5.87181C0 5.54037 0.118 5.25665 0.354 5.02065C0.59 4.78465 0.873722 4.66665 1.20517 4.66665H2V3.33331C2 2.50087 2.29189 1.79276 2.87567 1.20898C3.45944 0.625201 4.16756 0.333313 5 0.333313C5.83244 0.333313 6.54056 0.625201 7.12433 1.20898C7.70811 1.79276 8 2.50087 8 3.33331V4.66665H8.79483C9.12628 4.66665 9.41 4.78465 9.646 5.02065C9.882 5.25665 10 5.54037 10 5.87181V12.1281C10 12.4596 9.882 12.7433 9.646 12.9793C9.41 13.2153 9.12628 13.3333 8.79483 13.3333H1.20517ZM5 10.1666C5.32389 10.1666 5.59933 10.0532 5.82633 9.82631C6.05322 9.59931 6.16667 9.32387 6.16667 8.99998C6.16667 8.67609 6.05322 8.40065 5.82633 8.17365C5.59933 7.94676 5.32389 7.83331 5 7.83331C4.67611 7.83331 4.40067 7.94676 4.17367 8.17365C3.94678 8.40065 3.83333 8.67609 3.83333 8.99998C3.83333 9.32387 3.94678 9.59931 4.17367 9.82631C4.40067 10.0532 4.67611 10.1666 5 10.1666ZM3 4.66665H7V3.33331C7 2.77776 6.80556 2.30554 6.41667 1.91665C6.02778 1.52776 5.55556 1.33331 5 1.33331C4.44444 1.33331 3.97222 1.52776 3.58333 1.91665C3.19444 2.30554 3 2.77776 3 3.33331V4.66665Z"
                                          fill="#1C1B1F"
                                        />
                                      </svg>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </td>
                            );
                          })}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                </table>
              </>
            ) : (
              <>
                <NoDataFound />
              </>
            )}
          </div>
        )}
      </section>
      {/* </div> */}
      {/* </div> */}

      {updatePopup && (
        <InventoryUpdate
          onClose={handleClosePopup}
          inventoryData={inventoryData}
          startDate={startDate}
          InventoryDetails={InventoryDetails}
        />
      )}

      {updateDate && (
        <div className="popup_backdrop">
          <div className="popup_section">
            <div className="agent">
              <h4>Block Inventory</h4>
              <svg
                onClick={handleCloseUpdateDate}
                width="14"
                height="13"
                viewBox="0 0 14 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M1 12.5L13 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
                <path d="M13 12.5L1 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
              </svg>
            </div>
            <div>
              <div>
                <label htmlFor="">Start Date</label>
                <input
                  className="w-full"
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="" className="mt-10">
                  End Date
                </label>
                <input
                  className="w-full"
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <button
                className="vendor_common_property mt-10 w-full"
                type="button"
                onClick={() => fetchUpdateDate(selectedId)}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}

      {unblockedPopup && (
        <div className="popup_backdrop">
          <div className="popup_section p_20">
            <div>
              <div className="flex justify_content_between">
                <h4>Are you sure to unblock the inventory.</h4>
                <svg
                  onClick={() => setUnblockedPopup(false)}
                  width="14"
                  height="13"
                  viewBox="0 0 14 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M1 12.5L13 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
                  <path d="M13 12.5L1 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
                </svg>
              </div>

              <button
                className="vendor_common_property mt-10 w-full"
                type="button"
                onClick={() => fetchUnblockedDate(selectedId)}
              >
                Un-Block
              </button>
            </div>
          </div>
        </div>
      )}

      {showBookingSlider && (
        <SliderComponentSkeleton
          show={showBookingSlider}
          setShow={setShowBookingSlider}
          title={`Bulk Update: (${sliderHeading})`}
        >
          {sliderHeading === "Inventory" && (
            <SliderInventoryUpdate
              categories={inventoryData}
              currentDate={currentDate}
              selectedValues={selectedValues}
              setSelectedValues={setSelectedValues}
              baseUrl={baseUrl}
              property_id={id}
              userToken={vendorToken}
              setLoader={setLoader}
              channels={[]}
              setShow={setShowBookingSlider}
              activeApp={'pms'}
              viewType={viewType}
              room_id={selectedRoom.id}
              channel_id={selectedChannel?.channel_id}
              // fetchInfo={fetchInfo}
              fetchInfo={() => console.log('ll')}
            />
          )}

          {sliderHeading === "Block" && (
            <>
              <InventoryBulkBlock
                categories={inventoryData}
                currentDate={currentDate}
                selectedValues={selectedValues}
                setSelectedValues={setSelectedValues}
                baseUrl={baseUrl}
                property_id={id}
                userToken={vendorToken}
                setLoader={setLoader}
                channels={[]}
                setShow={setShowBookingSlider}
                permissions={null}
              />
            </>
          )}

          {sliderHeading === "Unblock" && (
            <div>
              <InventoryUnblock
                categories={categories}
                currentDate={currentDate}
                selectedValues={selectedValues}
                setSelectedValues={setSelectedValues}
                baseUrl={baseUrl}
                property_id={id}
                userToken={vendorToken}
                setLoader={setLoader}
                channels={[]}
                setShow={setShowBookingSlider}
                permissions={null}
                // fetchInfo={fetchInfo}
                fetchInfo={() => console.log('ll')}
              />
            </div>
          )}

          {sliderHeading === "Rates" && (
            <div>
              <InventoryRatesUpdate
                categories={inventoryData}
                currentDate={currentDate}
                selectedValues={selectedValues}
                setSelectedValues={setSelectedValues}
                baseUrl={baseUrl}
                property_id={id}
                userToken={vendorToken}
                setLoader={setLoader}
                setShow={setShowBookingSlider}
              />
            </div>
          )}




          {/* {(sliderHeading === "Stop Sell Active" ||
            sliderHeading === "Stop Sell Inactive") && (
              <>
                <InventoryStopSell
                  categories={categories}
                  currentDate={currentDate}
                  selectedValues={selectedValues}
                  setSelectedValues={setSelectedValues}
                  baseUrl={baseUrl}
                  property_id={property_id}
                  userToken={userToken}
                  setLoader={setLoader}
                  channels={channels}
                  type={sliderHeading}
                  setShow={setShowBookingSlider}
                  viewType={viewType}
                  room_id={selectedRoom.id}
                  channel_id={selectedChannel?.channel_id}
                  activeApp={activeApp}
                  fetchInfo={fetchInfo}
                />
              </>
            )} */}
          {/* {sliderHeading === "Stay Restrictions" && (
            <StayRestrictions
              categories={categories}
              currentDate={currentDate}
              selectedValues={selectedValues}
              setSelectedValues={setSelectedValues}
              baseUrl={baseUrl}
              property_id={property_id}
              userToken={userToken}
              setLoader={setLoader}
              channels={channels}
              setShow={setShowBookingSlider}
              activeApp={activeApp}
            />
          )} */}
          {/* 
          {sliderHeading === "Rates" && (
            <InventoryRatesUpdate
              categories={categories}
              currentDate={currentDate}
              selectedValues={selectedValues}
              setSelectedValues={setSelectedValues}
              baseUrl={baseUrl}
              property_id={property_id}
              userToken={userToken}
              setLoader={setLoader}
              channels={channels}
              setShow={setShowBookingSlider}
              viewType={viewType}
              room_id={selectedRoom.id}
              channel_id={selectedChannel?.channel_id}
              fetchInfo={fetchInfo}
            />
          )} */}
        </SliderComponentSkeleton>
      )}
    </>
  );
};

export default Inventory;

// const fetchUpdateDate = () => {
//   const myHeaders = new Headers();
//   myHeaders.append("key", process.env.REACT_APP_API_KEY);
//   myHeaders.append("Content-Type", "application/json");

//   const raw = JSON.stringify({
//     room_categories: [selectedId],
//     accommodation_id: id,
//     from_date: fromDate,
//     to_date: toDate,
//   });

//   const requestOptions = {
//     method: "POST",
//     headers: myHeaders,
//     body: raw,
//     redirect: "follow",
//   };

//   fetch(
//     `${process.env.REACT_APP_APP_URL}/api/v1/vendor/hotel-inventory/block`,
//     requestOptions
//   )
//     .then((response) => response.json())
//     .then((result) => {
//       if (result.success) {
//         setUpdateDate(false);
//         toast.success(result.message);
//         // console.log(result, "result");
//         InventoryDetails(id, startDate);
//         setFromDate("");
//         setToDate("");
//       }
//     })
//     .catch((error) => console.error(error));
// };
// const fetchUnblockedDate = () => {
//   const myHeaders = new Headers();
//   myHeaders.append("key", process.env.REACT_APP_API_KEY);
//   myHeaders.append("Content-Type", "application/json");

//   const raw = JSON.stringify({
//     room_categories: [selectedId],
//     accommodation_id: id,
//     from_date: fromDate,
//     to_date: toDate,
//   });

//   const requestOptions = {
//     method: "POST",
//     headers: myHeaders,
//     body: raw,
//     redirect: "follow",
//   };

//   fetch(
//     `${process.env.REACT_APP_APP_URL}/api/v1/vendor/hotel-inventory/unblock`,
//     requestOptions
//   )
//     .then((response) => response.json())
//     .then((result) => {
//       if (result.success) {
//         setUnblockedPopup(false);
//         toast.success(result.message);
//         InventoryDetails(id, startDate);
//         setFromDate("");
//         setToDate("");
//       }
//     })
//     .catch((error) => console.error(error));
// };
